<template>
  <v-list two-line :class="itemIndex = 0">
    <v-list-tile v-for="item in items" :key="item.product_id" avatar class="itemDivider">
      <v-list-tile-avatar>
          <img v-if="itemIndex === 0" src="/static/icon/ranking_icon-01.png" alt="">
          <img v-else-if="itemIndex === 1" src="/static/icon/ranking_icon-02.png" alt="">
          <img v-else-if="itemIndex === 2" src="/static/icon/ranking_icon-03.png" alt="">
          <span v-else>{{itemIndex + 1}}位</span>
      </v-list-tile-avatar>
      <v-list-tile-avatar>
        <play-btn
          :itemIndex="itemIndex"
          :itemTitle="item.name"
          :itemArtist="item.artist_name"
          :itemSrc="item.mp3"
          :itemProductId="item.product_id"
          :musicPlayerType="'ranking'"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
        <v-list-tile-sub-title @click="moveDetail(item.artist_id)" class="hover-type01">{{ item.artist_name }}</v-list-tile-sub-title>
      </v-list-tile-content>
      <v-spacer></v-spacer>
      <lyrics
        :title="item.name"
        :artist="item.artist_name"
        :lyrics="item.lyrics"
        :introduction="item.introduction"
      />
      <more-btn
        :class="itemIndex = itemIndex + 1"
        :addIsumBtn="false"
        :addCommentBtn="false"
        :addMusicBtn="false"
        :addListBtn="true"
        :addFavoriteBtn="true"
        :deleteListBtn="false"
        :productId="item.product_id"
      />
    </v-list-tile>
  </v-list>
</template>

<script>
import RankingService from '@/components/services/RankingService.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import Lyrics from '@/components/Lyrics.vue'
import PlayBtn from '@/components/PlayBtn.vue'
export default {
  name: 'RankingList',
  components: {
    MoreBtn,
    Lyrics,
    PlayBtn,
    RankingService
  },
  data () {
    return {
      items: {}
    }
  },
  props: {
    sceneId: Number
  },
  watch: {
    sceneId (val) {
      console.log(val)
      let transactionId = this.$store.state.transactionId
      if (val == null) {
        this.getAllRankingTunes(transactionId)
      } else {
        this.getSceneRankingTunes(transactionId, val)
      }
    }
  },
  created () {
    let transactionId = this.$store.state.transactionId
    this.getAllRankingTunes(transactionId)
  },
  methods: {
    /**
     * 総合ランキングを取得
     * @param transactionId
     **/
    getAllRankingTunes (transactionId) {
      this.logging('methods: getRankingTunes')
      RankingService.findAllRankingTune(transactionId, (response) => {
        this.items = response
        this.$store.dispatch('rankingListModuleSetPlayList', this.items)
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * シーン別ランキングを取得
     * @param transactionId
     **/
    getSceneRankingTunes (transactionId, sceneId) {
      this.logging('methods: getRankingTunes')
      RankingService.findSceneRankingTune(transactionId, sceneId, (response) => {
        this.items = response
        this.$store.dispatch('rankingListModuleSetPlayList', this.items)
      }, (error) => {
        this.logging(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RankingList.vue